import type { IAiChatMessage } from "@/types/AiChat/IAiChat";

export type AiChatMessageGroup =
    | { kind: "message"; key: string; message: IAiChatMessage }
    | { kind: "tools"; key: string; tools: IAiChatMessage[] };

export const groupToolStatusMessages = (
    messages: IAiChatMessage[],
): AiChatMessageGroup[] => {
    const groups: AiChatMessageGroup[] = [];

    for (const message of messages) {
        if (message.type !== "tool_status") {
            groups.push({
                kind: "message",
                key: `message-${message.id}`,
                message,
            });
            continue;
        }

        const last = groups[groups.length - 1];
        if (last !== undefined && last.kind === "tools") {
            last.tools.push(message);
            continue;
        }

        groups.push({
            kind: "tools",
            key: `tools-${message.id}`,
            tools: [message],
        });
    }

    return groups;
};
